import { useCallback, useEffect, useState } from "react";

import { toast } from "sonner";
import type {
  BlockchainNetwork,
  BlockchainNetworkQuery,
  PaginationMeta,
} from "@/interfaces/blockchainNetwork";
import { DEFAULT_PAGE_SIZE } from "@/interfaces/blockchainNetwork/constants";
import service from "@/components/admin-components/blockchain-network/service";

export const useBlockchainNetworks = () => {
  const [loading, setLoading] = useState(true);

  const [networks, setNetworks] = useState<BlockchainNetwork[]>([]);

  const [meta, setMeta] = useState<PaginationMeta>({
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
    total: 0,
    totalPages: 1,
  });

  const [query, setQuery] = useState<BlockchainNetworkQuery>({
    page: 1,
    limit: DEFAULT_PAGE_SIZE,
  });

  const fetchNetworks = useCallback(async () => {
    try {
      setLoading(true);

      const res = await service.getAll(query);

      setNetworks(res.data);
      setMeta(res.meta);
    } catch (error: any) {
      toast.error(
        error?.response?.data?.message ??
          "Unable to fetch blockchain networks.",
      );
    } finally {
      setLoading(false);
    }
  }, [query]);

  useEffect(() => {
    fetchNetworks();
  }, [fetchNetworks]);

  return {
    loading,

    networks,

    meta,

    query,

    setQuery,

    refresh: fetchNetworks,
  };
};
